// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PPzv","right":"Footer_right__3rLlK","buttons":"Footer_buttons__1to57"};